import { render } from "./RequestLoan.vue?vue&type=template&id=1c690b56"
import script from "./RequestLoan.vue?vue&type=script&lang=js"
export * from "./RequestLoan.vue?vue&type=script&lang=js"
script.render = render

export default script